export default __webpack_public_path__ + "static/media/Quiken_Pedidos_devoluciones-15.2280c026.svg";